import * as z from "zod";
import { conciergeSkillsSchema } from "./common/concierge-skills-schema";

export const updateConciergeSkillsSettings = {
  name: "updateConciergeSkillsSettings" as const,
  input: z.object({ settings: conciergeSkillsSchema }),
  output: z.null(),
};
